import { TimePeriod } from '@va/types/time';
import { useState } from 'react';

export function useTimePeriod() {
  const [timePeriod, setTimePeriod] = useState(TimePeriod.day);

  return { timePeriod, setTimePeriod };
}
